<template>
  <div class="finance-detail" :class="theme">
    <!-- <navigation :tabs="tabs" @input="onChangeTab" :theme="theme">
      <div v-for="(tab, index) in tabs" :key="index" :slot="'tab'+index" class="tab">
        {{tab.text}}
      </div>
    </navigation> -->

    <div class="content">
      <div class="vue-swiper">
        <swiper :options="listSwiperOption" ref="listSwiper" :autoHeight="true">
          <swiper-slide v-for="(list,index) in lists" class="swiper-slide-tab" :key="index">
            <div class="list">
              <!-- 主要指报 -->
              <div v-if="type==='quota'">
                <p class="stock-name" :class="theme">{{list.fiscalperiodenddate}}</p>
                <p class="dt-quota" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>{{list.single_income}}</dd>
                  <dd>{{list.peexclxor}}</dd>
                  <dd>{{list.single_income_rate}}</dd>
                  <dd>{{list.single_net_asset | precision(2)}}</dd>
                  <dd>{{list.mrk_net_rate | precision(2)}}</dd>
                  <dd>{{list.gross_profit_rate}}</dd>
                  <dd>{{list.net_profit_rate}}</dd>
                  <dd>{{list.net_asset_profit_rate}}</dd>
                  <dd>{{list.asset_profit_rate}}</dd>
                </dl>
              </div>
              <!-- 港股利润表 -->
              <div v-if="type==='profit' && (market==='HK'||market==='HKEX'||market==='HKSE')">
                <p class="stock-name" :class="theme">{{list.fiscalperiodenddate}}</p>
                <dl :class="theme">
                  <dd>{{list.rtlr | format('百万')}}</dd>
                  <dd>{{list.scor | format('百万')}}</dd>
                </dl>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>{{list.ssga | format('百万')}}</dd>
                  <dd>{{list.sinn | format('百万')}}</dd>
                  <dd>{{list.sdpr | format('百万')}}</dd>
                  <dd class="highlight" :class="theme">{{list.sopi | format('百万')}}</dd>
                  <dd>{{list.eibt | format('百万')}}</dd>
                  <dd>{{list.ttax | format('百万')}}</dd>
                  <dd class="highlight" :class="theme">{{list.tiat | format('百万')}}</dd>
                  <dd>- -</dd>
                </dl>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>{{list.cmin | format('百万')}}</dd>
                  <dd>{{list.sdni | format('百万')}}</dd>
                </dl>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>- -</dd>
                  <dd>{{list.sdbf | precision(2)}}</dd>
                  <dd>{{list.ddps1 | format('百万')}}</dd>
                </dl>
              </div>
              <!-- 美股利润表 -->
              <div v-if="type==='profit'&& (market==='US'||market==='NASDAQ'||market==='NYSE')">
                <p class="stock-name" :class="theme">{{list.fiscalperiodenddate}}</p>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>{{list.srev | format('百万')}}</dd>
                  <dd>{{list.sore | format('百万')}}</dd>
                  <dd>{{list.rtlr | format('百万')}}</dd>
                  <dd>{{list.scor | format('百万')}}</dd>
                  <dd>{{list.sgrp | format('百万')}}</dd>
                  <dd>{{list.ssga | format('百万')}}</dd>
                  <dd>{{list.erad | format('百万')}}</dd>
                  <dd>- -</dd>
                  <dd>- -</dd>
                  <dd>- -</dd>
                  <dd>{{list.sooe | format('百万')}}</dd>
                  <dd>{{list.etoe | format('百万')}}</dd>
                  <dd>{{list.sopi | format('百万')}}</dd>
                  <dd>- -</dd>
                  <dd>{{list.eibt | format('百万')}}</dd>
                  <dd>- -</dd>
                  <dd>{{list.tiat | format('百万')}}</dd>
                  <dd>0.00</dd>
                  <dd>- -</dd>
                  <dd>- -</dd>
                  <dd>{{list.cmin | format('百万')}}</dd>
                  <dd>{{list.sdni | format('百万')}}</dd>
                  <dd>- -</dd>
                </dl>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>- -</dd>
                  <dd>{{list.sdbf | precision(2)}}</dd>
                </dl>
              </div>
              <!-- 港股资产负债表 -->
              <div v-if="type==='assets' && (market==='HK'||market==='HKEX'||market==='HKSE')" :class="theme">
                <p class="stock-name" :class="theme">{{list.fiscalperiodenddate}}</p>
                <p class="asset" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>- -</dd>
                  <dd>{{list.atrc | format('百万')}}</dd>
                  <dd>{{list.aitl | format('百万')}}</dd>
                  <dd>{{list.atca | format('百万')}}</dd>
                </dl>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>{{list.aptc | format('百万')}}</dd>
                  <dd>{{list.aint | format('百万')}}</dd>
                  <dd>- -</dd>
                  <dd>- -</dd>
                </dl>
                <p class="total" :class="theme">{{list.atot | format('百万')}}</p>

                <p class="debt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>{{list.lapb | format('百万')}}</dd>
                  <dd>- -</dd>
                  <dd>{{list.ltcl | format('百万')}}</dd>
                </dl>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>- -</dd>
                </dl>
                <p class="total" :class="theme">{{list.ltll | format('百万')}}</p>
                <dl :class="theme">
                  <dd>- -</dd>
                  <dd>- -</dd>
                </dl>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>- -</dd>
                  <dd>{{list.lmin | format('百万')}}</dd>
                </dl>
                <p class="total" :class="theme">{{list.qtle | format('百万')}}</p>
              </div>
              <!-- 美股资产负债表 -->
              <div v-if="type==='assets'&& (market==='US'||market==='NASDAQ'||market==='NYSE')" :class="theme">
                <p class="stock-name" :class="theme">{{list.fiscalperiodenddate}}</p>
                <p class="asset" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>{{list.acae | format('百万')}}</dd>
                  <dd>{{list.asti | format('百万')}}</dd>
                  <dd>{{list.atrc | format('百万')}}</dd>
                  <dd>{{list.aitl | format('百万')}}</dd>
                  <dd>{{list.soca | format('百万')}}</dd>
                </dl>
                <p class="total" :class="theme">{{list.atca | format('百万')}}</p>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>{{list.sinv | format('百万')}}</dd>
                  <dd>{{list.aptc | format('百万')}}</dd>
                  <dd>{{list.agwi | format('百万')}}</dd>
                  <dd>{{list.aint | format('百万')}}</dd>
                  <dd>- -</dd>
                  <dd>- -</dd>
                  <dd>- -</dd>
                </dl>
                <p class="total" :class="theme">{{list.atot | format('百万')}}</p>
                <p class="debt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>{{list.lapb | format('百万')}}</dd>
                  <dd>- -</dd>
                  <dd>{{list.socl | format('百万')}}</dd>
                </dl>
                <p class="dt" :class="theme"><span style="visibility:hidden;">zhanwei</span></p>
                <dl :class="theme">
                  <dd>{{list.lttd | format('百万')}}</dd>
                  <dd>- -</dd>
                  <dd>{{list.lmin | format('百万')}}</dd>
                </dl>
                <p class="total" :class="theme">{{list.ltll | format('百万')}}</p>
                <dl :class="theme">
                  <dd>{{list.srpr | format('百万')}}</dd>
                  <dd>{{list.sprs | format('百万')}}</dd>
                  <dd>{{list.scms | format('百万')}}</dd>
                  <dd>- -</dd>
                  <dd>{{list.sote | format('百万')}}</dd>
                </dl>
                <p class="total" :class="theme">{{list.qtle | format('百万')}}
                  <span class="total-s">- -</span>
                </p>
              </div>
              <!-- 港股先金流量表 -->
              <div v-if="type==='cash' && (market==='HK'||market==='HKEX'||market==='HKSE')">
                <p class="stock-name" :class="theme">{{list.fiscalperiodenddate}}</p>
                <dl :class="theme">
                  <dd>{{list.otlo | format('百万')}}</dd>
                  <dd>{{list.itli | format('百万')}}</dd>
                  <dd>{{list.ftlf | format('百万')}}</dd>
                  <dd>- -</dd>
                  <dd>- -</dd>
                  <dd>{{list.sncc | format('百万')}}</dd>
                  <dd>{{list.sfee | format('百万')}}</dd>
                </dl>
              </div>
              <!-- 美股先金流量表 -->
              <div v-if="type==='cash' && (market==='US'||market==='NASDAQ'||market==='NYSE')">
                <p class="stock-name" :class="theme">{{list.fiscalperiodenddate}}</p>
                <p class="dt" :class="theme">- -</p>
                <dl :class="theme">
                  <dd>- -</dd>
                  <dd>- -</dd>
                  <dd>- -</dd>
                </dl>
                <p class="dt" :class="theme">{{list.otlo | format('百万')}}</p>
                <dl :class="theme">
                  <dd>{{list.scex | format('百万')}}</dd>
                  <dd>{{list.itli | format('百万')}}</dd>
                  <dd>{{list.samt | precision(2)}}</dd>
                </dl>
                <p class="dt" :class="theme">{{list.itli | format('百万')}}</p>
                <dl :class="theme">
                  <dd>- -</dd>
                  <dd>- -</dd>
                  <dd>- -</dd>
                </dl>
                <p class="dt" :class="theme">{{list.ftlf | format('百万')}}</p>
                <dl :class="theme">
                  <dd>{{list.sfee | format('百万')}}</dd>
                </dl>
                <p class="dt" :class="theme">{{list.sncc | format('百万')}}</p>
              </div>

            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev" :class="theme"></div>
          <div class="swiper-button-next" slot="button-next" :class="theme"></div>
        </swiper>
      </div>
      <p class="stock-name-text" :class="theme">{{stockName}}</p>
      <div class="details-name">
        <div v-if="type==='quota'">
          <p class="dt-quota" :class="theme">主要收益</p>
          <dl :class="theme">
            <dd>每股收益</dd>
            <dd>市盈率</dd>
            <dd>股息率</dd>
            <dd>每股净资产</dd>
            <dd>市净率</dd>
            <dd>毛利率</dd>
            <dd>净利率</dd>
            <dd>净资产收益率</dd>
            <dd>总资产收益率</dd>
          </dl>
        </div>
        <div v-if="type==='profit' && (market==='HK'||market==='HKEX'||market==='HKSE')">
          <dl :class="theme">
            <dd>营业收入</dd>
            <dd>销售成本</dd>
          </dl>
          <p class="dt" :class="theme">营运成本</p>
          <dl :class="theme">
            <dd>销售及分销费用</dd>
            <dd>利息费用／融资成本</dd>
            <dd>折旧</dd>
            <dd class="highlight" :class="theme">营业利润</dd>
            <dd>除税前盈利</dd>
            <dd>税项</dd>
            <dd class="highlight" :class="theme">税后利润</dd>
            <dd>除税后及股息后盈利</dd>
          </dl>
          <p class="dt" :class="theme">盈利分配</p>
          <dl :class="theme">
            <dd>少数股东权益／亏损</dd>
            <dd>归属于母公司股东的净利润</dd>
          </dl>
          <p class="dt" :class="theme">每股盈利</p>
          <dl :class="theme">
            <dd>基本每股盈利</dd>
            <dd>摊薄每股盈利</dd>
            <dd>每股股息</dd>
          </dl>
        </div>
        <div v-if="type==='profit' && (market==='US'||market==='NASDAQ'||market==='NYSE')">
          <p class="dt" :class="theme">损益明细</p>
          <dl :class="theme">
            <dd>营业收入</dd>
            <dd>其他收入</dd>
            <dd>营业总收入</dd>
            <dd>营业成本</dd>
            <dd>营业毛利率</dd>
            <dd>市场、营销和管理费用</dd>
            <dd>研发费用</dd>
            <dd>净利息费用</dd>
            <dd>
              <span class="highlight" :class="theme">其中：</span>利息收入</dd>
            <dd class="mg-l">利息支出</dd>
            <dd>其他营业费用</dd>
            <dd>其他费用合计</dd>
            <dd>营业利润</dd>
            <dd>持续经营业务特殊项目</dd>
            <dd>税前利润</dd>
            <dd>所得税</dd>
            <dd>税后利润</dd>
            <dd>已终止经营业务特殊项目</dd>
            <dd>净利润</dd>
            <dd>
              <span class="highlight" :class="theme">其中：</span>优先股股利</dd>
            <dd>归属于少数股东的净利润</dd>
            <dd>归属于母公司股东的净利润</dd>
            <dd>其他综合收益</dd>
          </dl>
          <p class="dt" :class="theme">每股收益</p>
          <dl :class="theme">
            <dd>基本每股收益</dd>
            <dd>稀释每股收益</dd>
          </dl>
        </div>
        <!-- 港股资产负债表 -->
        <div v-if="type==='assets' && (market==='HK'||market==='HKEX'||market==='HKSE')" :class="theme">
          <p class="asset" :class="theme">资产</p>
          <p class="dt" :class="theme">流动资产</p>
          <dl :class="theme">
            <dd>现金及银行结存</dd>
            <dd>应收账款</dd>
            <dd>存货</dd>
            <dd>流动资产小计</dd>
          </dl>
          <p class="dt" :class="theme">非流动资产</p>
          <dl :class="theme">
            <dd>物业、厂房及设备</dd>
            <dd>无形资产</dd>
            <dd>附属公司权益</dd>
            <dd>非流动资产小计</dd>
          </dl>
          <p class="total" :class="theme">总流动资产</p>

          <p class="debt" :class="theme">负债</p>
          <p class="dt" :class="theme">流动负债</p>
          <dl :class="theme">
            <dd>应付账款</dd>
            <dd>银行贷款</dd>
            <dd>流动负债小计</dd>
          </dl>
          <p class="dt" :class="theme">非流动负债</p>
          <dl :class="theme">
            <dd>非流动负债小计</dd>
          </dl>
          <p class="total" :class="theme">总负债</p>
          <dl :class="theme">
            <dd>净资产／负债</dd>
            <dd>净流动资产</dd>
          </dl>
          <p class="dt" :class="theme">股东权益</p>
          <dl :class="theme">
            <dd>股本</dd>
            <dd>少数股东权益-借／贷</dd>
          </dl>
          <p class="total" :class="theme">总权益</p>
        </div>

        <div v-if="type==='assets' && (market==='US'||market==='NASDAQ'||market==='NYSE')" :class="theme">
          <p class="asset" :class="theme">资产</p>
          <p class="dt" :class="theme">流动资产</p>
          <dl :class="theme">
            <dd>现金及现金等价物</dd>
            <dd>短期投资</dd>
            <dd>应收账款净额</dd>
            <dd>库存</dd>
            <dd>其它流动资产</dd>
          </dl>
          <p class="total" :class="theme">总资产</p>
          <p class="dt" :class="theme">非流动资产</p>
          <dl :class="theme">
            <dd>长期投资</dd>
            <dd>物业、厂房及设备</dd>
            <dd>商誉</dd>
            <dd>无形资产</dd>
            <dd>累计摊销</dd>
            <dd>其它资产</dd>
            <dd>递延的长期资产变化</dd>
          </dl>
          <p class="total" :class="theme">总资产</p>
          <p class="debt" :class="theme">负债</p>
          <p class="dt" :class="theme">流动负债</p>
          <dl :class="theme">
            <dd>应付账款</dd>
            <dd>短期/流动长期负债</dd>
            <dd>其它流动负债</dd>
          </dl>
          <p class="dt" :class="theme">非流动负债</p>
          <dl :class="theme">
            <dd>长期负债</dd>
            <dd>递延的长期负债变化</dd>
            <dd>少数股东权益</dd>
          </dl>
          <p class="total" :class="theme">总负债</p>
          <dl :class="theme">
            <dd>可赎回优先级</dd>
            <dd>优先股</dd>
            <dd>普通股</dd>
            <dd>库存股票</dd>
            <dd>其它股东权益</dd>
          </dl>
          <p class="total" :class="theme">总权益
            <span class="total-s">有型资产净值</span>
          </p>
        </div>

        <div v-if="type==='cash' && (market==='HK'||market==='HKEX'||market==='HKSE')">
          <dl :class="theme">
            <dd>经营现金流入</dd>
            <dd>投资现金流入</dd>
            <dd>融资现金流入</dd>
            <dd>年初现金及等价物</dd>
            <dd>年终现金及等价物</dd>
            <dd>现金及等价物增加</dd>
            <dd>外汇兑换率变动之影响</dd>
          </dl>
        </div>
        <!--美股 -->
        <div v-if="type==='cash' && (market==='US'||market==='NASDAQ'||market==='NYSE')">
          <p class="dt" :class="theme">净利</p>
          <dl :class="theme">
            <dd>折旧</dd>
            <dd>净利调整</dd>
            <dd>在其它经营活动中的变化</dd>
          </dl>
          <p class="dt" :class="theme">经营性现金流</p>
          <dl :class="theme">
            <dd>资本支出</dd>
            <dd>投资</dd>
            <dd>其它投资活动产生的现金流</dd>
          </dl>
          <p class="dt" :class="theme">投资性现金流</p>
          <dl :class="theme">
            <dd>支付的股息</dd>
            <dd>净借贷</dd>
            <dd>其它融资活动产生的现金流</dd>
          </dl>
          <p class="dt" :class="theme">筹资性现金流</p>
          <dl :class="theme">
            <dd>汇率变动的影响</dd>
          </dl>
          <p class="dt" :class="theme">现金及现金等值项目变更</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Navigation from '@/components/navigation.vue'
import 'swiper/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import format from '@/filters/format'
import precision from '@/filters/precision'
import {request} from '@/api/request'

export default {
  props: ['options'],
  data() {
    return {
      data: null,
      // tabs: [
      //   {text: '全部', timeSlot: 'all'},
      //   {text: '季报', timeSlot: 'interim'},
      //   {text: '年报', timeSlot: 'annual'}],
      listSwiperOption: {
        autoplay: false,
        initialSlide: 0,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        }
      },
      theme: ''
    }
  },
  computed: {
    type () {
      return this.options.financetType && this.options.financetType.toLowerCase()
    },
    symbol () {
      return this.options.symbol
    },
    market () {
      return this.options.market && this.options.market.toUpperCase()
    },
    stockName () {
      return this.data && this.data.stock && this.data.stock.name
    },
    lists () {
      return this.data && this.data.list
    },
    timeSlot () {
      return this.options.key || 'all'
    }
  },
  filters: { format, precision },
  // Navigation
  components: {  swiper, swiperSlide },
  watch: {
    options: {
      immediate: true,
      handler() {
        this.getData()
      }
    }
  },
  methods: {
    async onChangeTab (index) {
      this.timeSlot = this.tabs[index].timeSlot
      this.getData()
    },
    async getGmgFinanceDetail(type, symbol, timeSlot) {
      const types = {
        profit: 'income',
        assets: 'debt',
        cash: 'cash_stream',
        quote: 'quote'
      }
      const fType = types[type] || 'quote'
      const url = type === 'quota' ? request.apis.quote.financeStockQuota : request.apis.quote.financeStockFinance
      const params = {
        f_type: fType,
        symbol,
        type: timeSlot
      }
      return request.get({
        url,
        params
      })
    },
    async getData () {
      this.data = await this.getGmgFinanceDetail(this.type, this.symbol, this.timeSlot)
      let obj = {};
      let list = this.data.list.slice(0)
      this.data.list = list.reduce(function(item, next) {
        obj[next.fiscalperiodenddate] ? '' : obj[next.fiscalperiodenddate] = true && item.push(next);
        return item;
      }, []);
      this.$emit('changeCurrency', this.data.stock.currency)
      this.$refs.listSwiper.swiper.slideTo(0, 0, true);
    }
  }
}
</script>

<style lang="stylus" scoped>
.finance-detail {
  width: 100%;
  font-size: .15rem;
  min-height: 100vh;
  font-family: PingFangSC-Regular;
  background: #ffffff;
}

.finance-detail.light {
  background: #f8f9fe;
}

.finance-detail.dark {
  background: #161825;
  color: #999999;
}

.navigation {
  // width: 100%;
  height: 0.34rem;
  line-height: 0.34rem;
  color: #262D40;
  font-weight: 500;
}

.tab {
  line-height: .34rem;
}

.content {
  position: relative;
}

.content.dark {
  background: #161825;
}

.stock-name-text {
  background: #F5F5F9;
  // width: 100%;
  height: .52rem;
  line-height: .52rem;
  font-size: .2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #0A1428;
  padding: 0 .15rem;
}

.stock-name {
  background: #F5F5F9;
  width: 100%;
  height: .52rem;
  line-height: .52rem;
  font-size: .13rem;
  color: #596E98;
  text-align: center;
  // padding-right: .14rem;
}

.stock-name.dark, .stock-name-text.dark{
  background: #1a1e2e;
  color: #ffa980;
}

.details-name {
  width: 100%;
}
.details-name
  div.dark {
    height: max-content;
    background: #161825;
  }
.details-name
  div.light {
    height: max-content;
    background: #f8f9fe;
  }

dl {
  background: white;
  padding: 0 .15rem;
  padding-bottom: .1rem;
  margin: 0;
}

dl.dark {
  background: #1a1e2e;
}

dd {
  height: .33rem;
  padding: .1rem 0;
  color: #262D40;
  margin: 0;
}

.dark
  dd {
    color: helper-color;
  }


.dt, .dt-quota {
  font-size: .16rem;
  line-height .22rem;
  font-family:PingFangSC-Medium;
  font-weight: 500;
  background: #ffffff;
  color: #596E98;
  padding: .16rem .15rem .1rem .15rem;
  position: relative;
}
.dt-quota {
  padding: .1rem .15rem;
}
.dt:before {
  content: '';
  display: block;
  width: 100%;
  height: .06rem;
  background-color: #F5F6FA;
  position: absolute;
  left: 0;
  top: 0;
}
.dt:after, .dt-quota:after {
  content: '';
  display: block;
  width: calc(100% - .2rem);
  height: .01rem;
  background-color: #EDEFF3;
  position: absolute;
  left: .1rem;
  bottom: -.01rem;
}

.dt.dark {
  background: #242a40;
  color: #cccccc;
}


.highlight {
  color: #E63535;
}

.highlight.dark {
  color: #ffa980;
}



.asset, .debt {
  background: #ffffff;
  color: #262D40;
  padding: .1rem .15rem .1rem .15rem;
  font-size: .13rem;
  line-height: .25rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
}

.debt.dark {
  padding-top: .12rem
}

.asset.dark, .debt.dark {
  background: #161825;
  color: #ffa980;
}

.total {
  border-top: .5px solid border-color;
  padding: .1rem .15rem;
  background: white;
  line-height: 1.55;
  font-family: PingFangSC-Medium;
  font-weight: 500;
}

.total.dark {
  border-top: .5px solid #12141f;
  background: #1a1e2e;
}

.vue-swiper {
  position: absolute;
  width: 34%;
  right: 0;
  top: 0;
  text-align: right;
  font-size: .15rem;
  z-index: 2;

  .swiper-container {
    p, dl, .dt, dd {
      background: none;
    }
  }
}

.swiper-button-prev,
.swiper-button-next { 
  position: absolute;
  top: 0;
  width:  0.09rem;
  height: 0.14rem;
  margin-top: 0.19rem;
  z-index: 10;
  cursor: pointer;
  background-size: 0.09rem 0.14rem;
  background-position: center;
  background-repeat: no-repeat;
  outline: none;
  border: none;
}


.swiper-button-next {
  right: .12rem;
  left: auto;
}

.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after ,.swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after{
  content: ''
}
.swiper-button-next {
  background: url("../../../../../assets/icons/arrow-right.png") no-repeat center / 100%;
}

.swiper-button-prev {
  left: 0;
  right: auto;
}

.swiper-button-prev {
  background: url("../../../../../assets/icons/arrow-left.png") no-repeat center / 100%;
}

.mg-l {
  padding-left: 0.45rem;
}

.total-s {
  display: block;
  padding-top: .09rem;
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0.6;
}
</style>